import React from 'react';
import Link from 'next/link';
import { trackCustomEvent } from 'app/utils/statistics/clientStatistics';
import {
    trackModalTitle,
    trackModalEpisode,
    trackModalAccessibilityVariant,
} from 'app/utils/statistics/customEvents';
import { useDispatch } from 'react-redux';
import { updateAccessVersionChoice } from 'app/actions/videoPage';
import { AccessibilityVariantsFragment } from 'app/graphql/__generated__/types/contento';
import VariantLinks from 'app/components/VariantLinks/VariantLinks';
import {
    ProgramInfoTitle,
    ProgramInfoTitleLink,
    ProgramInfoEpisodeLink,
    ProgramInfoDivider,
} from './ProgramInfo.styles';

const ProgramInfo = ({
    title,
    episodeTitle,
    url,
    videos,
    selectedVideoId,
    parentUrl,
}: {
    title: string;
    episodeTitle: string;
    url: string;
    videos: Array<AccessibilityVariantsFragment>;
    selectedVideoId: string;
    parentUrl: string;
}) => {
    const dispatch = useDispatch();

    if (!title || !episodeTitle) {
        return null;
    }

    const updateAccessibilityVersion = (accessibility: string) => {
        dispatch(updateAccessVersionChoice(accessibility));
    };

    const trackTitleClick = () => {
        trackCustomEvent(trackModalTitle(selectedVideoId));
    };

    const trackEpisodeClick = () => {
        trackCustomEvent(trackModalEpisode(selectedVideoId));
    };

    const trackAccessabilityVariantClick = (variant) => {
        trackCustomEvent(trackModalAccessibilityVariant(variant));
    };

    return (
        <>
            <ProgramInfoTitle data-rt="program-info-title">
                <Link
                    href={{
                        pathname: parentUrl,
                    }}
                    passHref
                >
                    <ProgramInfoTitleLink data-rt="title-link" onClick={trackTitleClick}>
                        {title}
                    </ProgramInfoTitleLink>
                </Link>

                {title !== episodeTitle && (
                    <>
                        <ProgramInfoDivider />
                        <Link
                            href={{
                                pathname: url,
                            }}
                            passHref
                        >
                            <ProgramInfoEpisodeLink onClick={trackEpisodeClick} data-rt="episode-link">
                                {episodeTitle}
                            </ProgramInfoEpisodeLink>
                        </Link>
                    </>
                )}
            </ProgramInfoTitle>
            <VariantLinks
                videos={videos}
                selectedVideoId={selectedVideoId}
                onClick={(version) => {
                    trackAccessabilityVariantClick(version);
                    updateAccessibilityVersion(version);
                }}
                context="top-bar"
            />
        </>
    );
};

export default ProgramInfo;
